<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <MensagemAlerta class="row-space" v-if="msg" :mensagem="msg" />

    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ formatInteger(objEdicao.id) }}</div>
            </div>
            <div class="form-item">
                <label class="label-caption">Nome Conta</label>
                <input type="text" v-model="objEdicao.nmconta" maxlength="80" v-uppercase />
            </div>
            <div class="form-item">
                <label class="label-caption">Nome Remetente</label>
                <input type="text" v-model="objEdicao.nmremetente" maxlength="80" v-uppercase />
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Host</label>
                <input type="text" v-model="objEdicao.smtphost" maxlength="80" />
            </div>
            <div class="form-item">
                <label class="label-caption">Nome Usuário</label>
                <input type="text" v-model="objEdicao.smtpuser" maxlength="80" />
            </div>
            <div class="form-item">
                <label class="label-caption" for="smtppass">Senha</label>
                <input type="password" v-model="objEdicao.smtppass" autocomplete="password" maxlength="80" />
            </div>
            <div class="form-item-char10">
                <label class="label-caption">Porta</label>
                <input type="text" class="input-right" v-model="edSmtpPort" v-number maxlength="9" />
            </div>
        </div>
        

        <div class="row-end row-space">
            <label for="ckAtivo">Ativo</label>
            <input type="checkbox" class="input-checkbox" id="ckAtivo" v-model="ckAtivo" />
        </div>

        <div class="row-end row-space">
            <label for="ckEmailSSL">Email SSL</label>
            <input type="checkbox" class="input-checkbox" id="ckEmailSSL" v-model="ckEmailSSL" />
        </div>

        <div class="row-end row-space">
            <label for="ckEmailTLS">Email TLS</label>
            <input type="checkbox" class="input-checkbox" id="ckEmailTLS" v-model="ckEmailTLS" />
        </div>

        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>
</template>
  
<script setup>
import { criarContaEmail } from '@/models/contaEmail';
import { onMounted, ref } from 'vue';
import { formatInteger, integerFromString } from '@/funcoes/utils';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const ckAtivo = ref(false);
const ckEmailSSL = ref(false);
const ckEmailTLS = ref(false);
const edSmtpPort = ref(null);
const isLoading = ref(false);
const msg = ref(null);
const objEdicao = ref(criarContaEmail());

const cancelForm = () => {emit('close');}

const lerDados = async() => {
    try{
        isLoading.value = true;
        msg.value       = null;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('contaemail', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msg.value = error}
        }else{
            objEdicao.value.idep        = globalStore.idep;
            objEdicao.value.idlogin     = globalStore.idlogin;
        }
        objEdicao.value.idusuario       = globalStore.idusuario;
        ckAtivo.value                   = objEdicao.value.ativo === 'S';        
        ckEmailSSL.value                = objEdicao.value.emailssl === 'S';        
        ckEmailTLS.value                = objEdicao.value.emailtls === 'S';      
        edSmtpPort.value                = formatInteger(objEdicao.value.smtpport);  
    } catch (error) {msg.value = error;
    }finally{isLoading.value=false;}
};

const salvarDados = async() => {
    if (!objEdicao.value.nmconta || objEdicao.value.nmconta.trim() === '') {msg.value='Informe o nome da conta'; return;}
    try {
        isLoading.value             = true;
        msg.value                   = null;
        objEdicao.value.ativo       = ckAtivo.value ? 'S' : 'N';
        objEdicao.value.emailssl    = ckEmailSSL.value ? 'S' : 'N';
        objEdicao.value.emailtls    = ckEmailTLS.value ? 'S' : 'N';
        objEdicao.value.smtpport    = integerFromString(edSmtpPort.value);  
        const response              = await genericPut('/cad/contaemail', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msg.value = response.erro;
        }
    } catch (error) {msg.value = error;
    } finally{isLoading.value=false;}
};

onMounted(lerDados);
</script>